import {METHOD} from "services/method";

export const API_ORDER = {
    LIST: {
        api: '/v1/dashboard-admin/order/list',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/order/export',
        method: METHOD.POST,
    },
    CHANGE_STATUS: {
        api: '/v1/dashboard-admin/order/update',
        method: METHOD.PUT,
    },
    BULK_CHANGE_STATUS: {
        api: '/v1/dashboard-admin/order/bulk-update',
        method: METHOD.PUT,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/order/detail',
        method: METHOD.GET,
    },
    TRACKING_AWB: {
        api: '/v1/dashboard-admin/order/track',
        method: METHOD.GET,
    },
    LOG: {
        api: '/v1/dashboard-admin/order/log',
        method: METHOD.GET,
    },
    SEARCH_PRODUCT: {
        api: '/v1/dashboard-admin/order/products',
        method: METHOD.GET,
    },
    SEARCH_VOUCHER: {
        api: '/v1/dashboard-admin/order/vouchers',
        method: METHOD.GET,
    },
}
